import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the ReportsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReportsServiceProvider {

    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }

    /**
     * @Info Get Sales Report
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    sendSalesReport(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Report/sendSaleReport', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Get Inventory Report
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    sendInventoryReport(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Report/sendInventoryReport', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/reports-service/reports-service.ts